export default {
  props: {
    className: {
      default: () => {},
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    textarea: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 4,
    },
    left: {
      type: String,
      default: null,
    },
    right: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: [Object, Array],
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: null,
    },
  },
  computed: {
    internalErrors() {
      const errors = [];
      if (!Array.isArray(this.errors)) {
        // Parse validation Object
        if (this.errors.$dirty === true) {
          Object.keys(this.errors.$params).forEach(key => {
            if (Object.prototype.hasOwnProperty.call(this.errors, key)
                && this.errors[key] === false) {
              errors.push(this.parseError(key, this.errors.$params[key]));
            }
          });
        }
      } else {
        this.errors.forEach(e => errors.push(this.parseError(e, 'single')));
      }
      return errors;
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },
    onChange(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    },
    parseError(key, param) {
      if (param) {
        if (param === 'single') {
          return this.$t('error.single', { error_name: key });
        } else if (param.type === 'maxLength') {
          return this.$t('error.validation.maxLength', { length: param.max });
        } else if (param.type === 'minLength') {
          return this.$t('error.validation.minLength', { length: param.min });
        } else if (param.type === 'channelBudget') {
          return this.$t('error.validation.isValidBudgetChannel', { channels: param.channels, budget: param.budget });
        }
      }
      return this.$t('fn.complex.error', { error_group: 'validation', error_name: key });
    },
    clearValue() {
      this.$emit('clear', null);
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/form-input/FormInput.js